import { API } from 'aws-amplify';

import { listDriverQualifications } from '../../../graphql/queries';

const LIMIT = 1000;

const paginateQuery = async ({ query, variables, resultKey }) => {
  let allItems = [];
  let token;
  do {
    const response = await API.graphql({
      query,
      variables: { ...variables, nextToken: token },
    });
    const result = response?.data?.[resultKey];
    allItems = [...allItems, ...(result?.items || [])];
    token = result?.nextToken;
  } while (token);
  return allItems;
};

export const getSearchFilterOptions = async () => {
  const items = await paginateQuery({
    query: listDriverQualifications,
    resultKey: 'listDriverQualifications',
    variables: { limit: LIMIT },
  });

  const drivers = new Map();
  const clients = new Map();
  const branches = new Map();

  items.forEach(item => {
    if (item.driverName && item.driverId) {
      drivers.set(item.driverId, { driverId: item.driverId, driverName: item.driverName });
    }
    if (item.name && item.customerId) {
      clients.set(item.customerId, { customerId: item.customerId, clientName: item.name });
    }
    if (item.branch != null && Number.isFinite(Number(item.branch))) {
      branches.set(item.branch, { branch: item.branch });
    }
  });

  return {
    drivers: [...drivers.values()].sort((a, b) => a.driverName.localeCompare(b.driverName)),
    clients: [...clients.values()].sort((a, b) => a.clientName.localeCompare(b.clientName)),
    branches: [...branches.values()].sort((a, b) => Number(a.branch) - Number(b.branch)),
  };
};

export const searchDriverQualifications = async searchCriteria => {
  const conditions = [];

  if (searchCriteria.dqfNumber) {
    conditions.push({ id: { eq: searchCriteria.dqfNumber.trim() } });
  }

  if (searchCriteria.driverName) {
    conditions.push({ driverName: { contains: searchCriteria.driverName.trim() } });
  }

  if (searchCriteria.status?.length === 1) {
    conditions.push({ status: { eq: searchCriteria.status[0] } });
  } else if (searchCriteria.status?.length > 1) {
    conditions.push({ or: searchCriteria.status.map(s => ({ status: { eq: s } })) });
  }

  if (searchCriteria.clientName) {
    conditions.push({ name: { contains: searchCriteria.clientName.trim() } });
  }

  if (searchCriteria.dqSpecialist) {
    conditions.push({ dqOwnerFullName: { contains: searchCriteria.dqSpecialist.trim() } });
  }

  if (searchCriteria.branch?.length === 1) {
    conditions.push({ branch: { eq: parseInt(searchCriteria.branch[0], 10) } });
  } else if (searchCriteria.branch?.length > 1) {
    conditions.push({ or: searchCriteria.branch.map(b => ({ branch: { eq: parseInt(b, 10) } })) });
  }

  const { createdDateFrom, createdDateTo } = searchCriteria;
  if (createdDateFrom && createdDateTo) {
    const from = createdDateFrom <= createdDateTo ? createdDateFrom : createdDateTo;
    const to = createdDateFrom <= createdDateTo ? createdDateTo : createdDateFrom;
    conditions.push({ createdAt: { between: [`${from}T00:00:00.000Z`, `${to}T23:59:59.999Z`] } });
  } else if (createdDateFrom) {
    conditions.push({ createdAt: { ge: `${createdDateFrom}T00:00:00.000Z` } });
  } else if (createdDateTo) {
    conditions.push({ createdAt: { le: `${createdDateTo}T23:59:59.999Z` } });
  }

  const filter = conditions.length === 1 ? conditions[0] : conditions.length > 1 ? { and: conditions } : undefined;

  return await paginateQuery({
    query: listDriverQualifications,
    resultKey: 'listDriverQualifications',
    variables: {
      ...(filter && { filter }),
      limit: LIMIT,
    },
  });
};
